define([
	"dojo/_base/declare",
	"csi",
	"csi/def",
	"csi/form/Widget",
	"csi/reflection",
	"csi/store/_base",
	"csi/utility/pathUtility",
	"csi/xml",
], function(declare, csi, def, Widget, reflection, csiStore, {pathCreate}, xml) {

	const LINK_TO_STYLE = "PromoteToShape_LinkToStyle",
	SHAPE_MASTER_NAME = "ShapeMasterName",
	SHAPE_SIZE_RANGE = "ShapeSizeRange",
	SHAPE_SEASONS = "ShapeSeasons";
	COMBINED_FORM_TYPE = "ShapeMaster";

	return declare(Widget, {
        /**	Value is set to true on PromoteToShape to add specific fields */
		isPromoteAction: false,
		/** Style from the new shape will be created - Useful for Promote and New Shape From Style Actions */
		fromStyle: null,
 		/**	Value is set to true on copyShape to add specific fields */
		isCopyShapeAction: false,

		styleLinkedToShapeComment: null,

		styleNotLinkedToShapeComment: null,

		_getStoreOptions: function(/*Field*/ field) {
			return csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship);
		},

		/**
		 * Return field for ShapeMaster AllSeasons attribute, if any
		 * @return {Field | null}
		 */
		_getAllSeasonsField() {
			const name = this.getCombinedFieldName("ShapeMaster", "AllSeasons");
			return this.defView.getField(name);
		},

		/**
		 * Determine if parent Master is all season, or if Shape Master Business Object is configured as AllSeasons = true
		 * @return {boolean}
		 */
		_isAllSeasons() {
			const shape = this.getViewNode();
			const master = this.cacheView.get(shape?.__Parent__);
			const ra = reflection.getTypeAttribute("ShapeMaster", "AllSeasons");
			return master?.AllSeasons || !!ra.initialValue;
		},

		/**
		 * @override
		 * Combine master form if New/Edit action, and add onChange logic for AllSeasons field
		 */
		_resolveView() {
			if (this.isNew() || this.isEdit() || this.isCopyShapeAction) {
				this.combineForm(true, xml.ATTR_PARENT, COMBINED_FORM_TYPE);
			}

			this.inherited(arguments);
			const fd = this.getFormData();

			const fAllSeasons = this._getAllSeasonsField();
			if (fAllSeasons) {
				fAllSeasons.m_onChange = (defView, field, value) => {
					// reset Seasons field value if AllSeasons checked
					if (value) {
						this.setFieldValue(SHAPE_SEASONS, []);
					}
				};
			} else if (this._isAllSeasons()) {
				// remove Seasons field if master is AllSeasons
				this.defView.removeField(SHAPE_SEASONS);
			}
			if(this.isPromoteAction) {
				this.fromStyle = fd.getNode() || this.fromStyle;
				fd.setNode(null);
				
				if(this.fromStyle) { // Promote to Shape from Style Case
					this.insertFieldIfNotExist(LINK_TO_STYLE, 0, {
						m_typeControl: def.FIELD_CHECKBOX,
						m_onChange: "_onChangeLinkToStyle",
					});
		
					this.insertFieldIfNotExist(xml.isValidURL(this.fromStyle.Shape) ? "PromoteToShape_StyleLinkedToShape" : "PromoteToShape_EstablishNewLink", 1, {
						m_typeControl: def.FIELD_COMMENT,
					});
		
					this.insertFieldIfNotExist(SHAPE_MASTER_NAME, 2, {
						m_typeControl: def.FIELD_TEXT,
					});
		
					this.addFixedValue(SHAPE_SEASONS, this.fromStyle.ParentSeason);
					this.getField(SHAPE_SEASONS).m_bRequired = true;
		
					this.insertFieldIfNotExist(SHAPE_SIZE_RANGE, {
						m_typeControl: def.FIELD_FILTERING_SELECT,
						bForceEditable: true,
					});

				} 
			}else if(this.isCopyShapeAction){
				
				const combinedMasterFieldName = this.getCombinedFieldName(COMBINED_FORM_TYPE, xml.ATTR_NAME);
				const masterField = this.insertFieldIfNotExist(combinedMasterFieldName, 2, {
					m_id: xml.ATTR_NAME,
					m_path: pathCreate(xml.ATTR_PARENT),
					bCanEdit: false,
					combinedFormType: COMBINED_FORM_TYPE
				});
				
				this.setFieldDisabled(masterField, true);

				fd.setFieldInitialValue(SHAPE_SEASONS, "");

				this.insertFieldIfNotExist(SHAPE_SIZE_RANGE, {
					m_typeControl: def.FIELD_FILTERING_SELECT,
					bForceEditable: true,
				});
			}
		},

		/**
		 * @override
		 * If the AllSeasons field is on the form, then the ShapeSeasons field should be disabled if AllSeasons is checked
		 */
		_updateFieldVisibility(field) {
			const allSeasonsField = this._getAllSeasonsField();
			if (allSeasonsField) {
				this.setFieldDisabled("ShapeSeasons", allSeasonsField.getValue());
			}

			return this.inherited(arguments);
		},

		/**
		 * * @param {View} defView
		 * From Promote to Shape action, disable Shape Size Range field and add fixed value Style size range if the style has a size range.
		 */
		_onChangeLinkToStyle(defView) {
			let styleURL = this.fromStyle.$URL;
			let isLinkedToStyle = this.getFieldValue(LINK_TO_STYLE);
			if(styleURL) {
				const style = this.getCache().getNode(styleURL);
				const styleAttributes = this.getCache().getNode(style.Attributes);
				
				if (isLinkedToStyle && styleAttributes.ActualSizeRange != csi.EMPTY_URL) {
					this.setFieldDisabled(this.getField(SHAPE_SIZE_RANGE), true);
					this.setFieldValue(SHAPE_SIZE_RANGE, styleAttributes.ActualSizeRange);
				} else {
					this.setFieldDisabled(this.getField(SHAPE_SIZE_RANGE), false);
					this.setFieldValue(SHAPE_SIZE_RANGE, csi.EMPTY_URL);
				}
			}
		},
	});
});
